import { render, staticRenderFns } from "./OnboardingConfirmationToken.vue?vue&type=template&id=0ef3ed06&scoped=true"
import script from "./OnboardingConfirmationToken.vue?vue&type=script&lang=js"
export * from "./OnboardingConfirmationToken.vue?vue&type=script&lang=js"
import style0 from "./OnboardingConfirmationToken.vue?vue&type=style&index=0&id=0ef3ed06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef3ed06",
  null
  
)

export default component.exports